const selectIpRangeListData = (state) => state.settings.simulator.ignoreIpRange.ipRangeListData
const selectIpModalData = (state) => state.settings.simulator.ignoreIpRange.ipModalData

const selectIpRuleIdsToRemove = (state) => {
  const ruleId = selectIpModalData(state).id
  if (ruleId) return [ruleId]
  return selectIpRangeListData(state).selectedItems
}

const selectIpModalErrorMessage = (state) => {
  const error = selectIpModalData(state).error
  const rawValuesError = error?.response?.rawValues

  if (Array.isArray(rawValuesError)) return rawValuesError.join(', ')
  return rawValuesError || error?.detail || null
}

export {
  selectIpRangeListData,
  selectIpModalData,
  selectIpModalErrorMessage,
  selectIpRuleIdsToRemove,
}
